<mat-dialog-actions>
  <button class="material-icons" mat-dialog-close
          particleAnalytics
          analyticsCategory= "share-items-diaolog"
          analyticsAction= "close-btn">close</button>
</mat-dialog-actions>
<mat-dialog-content class="w-p-100 flex flex-col justify-between items-center">
<particle-add-contact-form (contactDetails)="onContactValueChanged($event)" [dialogRef]="dialogRef"></particle-add-contact-form>
</mat-dialog-content>
<mat-dialog-actions class="modal-footer flex flex-row justify-between items-center">
  <button mat-button class="orbitax-footer-button" mat-dialog-close
          particleAnalytics
          analyticsCategory= "share-items-dialog"
          analyticsAction= "cancel-btn">Cancel</button>
  <button mat-button [disabled]="addContactDetails?.status?.toLowerCase() === 'invalid'" class="orbitax-footer-action-button" type="button" (click)=onAddContact()
          particleAnalytics
          analyticsCategory= "add-contact"
          analyticsAction= "done-btn">
    Add Contact
  </button>
</mat-dialog-actions>
